export { positionElements, Positioning } from './ng-positioning';
export { PositioningService } from './positioning.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/~/ngx-bootstrap/positioning/index.js
// module id = ../../../../ngx-bootstrap/positioning/index.js
// module chunks = 3